module.exports = __webpack_public_path__ + "img/content3.9e584f9d.png";